import { Card, Container, Table, TableBody, TableContainer } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import AppLoadingAndErrorWrapper from 'src/components/common/AppLoadingAndErrorWrapper';
import FormProvider from 'src/components/hook-form/form-provider';
import Scrollbar from 'src/components/scrollbar';
import { TableHeadCustom, TablePaginationCustom, TableSkeleton } from 'src/components/table';
import AppTableToolbar from 'src/components/table/AppTableToolbar';
import AppPermissions from 'src/constants/app-permissions';
import { CERTIFICATES_TABLE_HEAD } from 'src/constants/tables-heads';
import { Order_By } from 'src/graphql';
import CertificatesRow from './certificates-row';
import useCertificates from './use-certificates';

export type KnowledgeBasesFormType = {
  sortBy: string | undefined;
  sortDirection: Order_By.Asc | Order_By.Desc | undefined;
};

const Certificates = () => {
  const {
    data,
    handleDeleteCert,
    handleSearch,
    isDeleting,
    isLoading,
    methods,
    query,
    setQuery,
    t,
    table
  } = useCertificates();

  return (
    <Container>
      <Helmet>
        <title>{t('sidebar.certificates.table')}</title>
      </Helmet>
      <AppLoadingAndErrorWrapper isLoading={isDeleting} errorMessage={null}>
        <Card>
          <FormProvider methods={methods}>
            <AppTableToolbar
              handleSearch={handleSearch}
              tableName=""
              buttons={[
                {
                  path: 'new',
                  permissionName: AppPermissions.KNOWLEDGE_BASES_CREATE,
                },
              ]}
              search={query.search!}
            />
            <TableContainer>
              <Scrollbar>
                <Table>
                  <TableHeadCustom
                    setQuery={setQuery}
                    headLabel={CERTIFICATES_TABLE_HEAD(t)}
                    methods={methods}
                  />
                  <TableBody>
                    {isLoading || isDeleting ? (
                      [...Array(table.rowsPerPage)].map((i, index) => (
                        <TableSkeleton key={index} sx={{ height: 80 }} />
                      ))
                    ) : (
                      <>
                        {data?.certificates?.map((row) => (
                          <CertificatesRow
                            key={row.certificateId}
                            row={row}
                            deleteHandler={handleDeleteCert}
                          />
                        ))}
                      </>
                    )}
                  </TableBody>
                </Table>
              </Scrollbar>
            </TableContainer>
            {data && (
              <TablePaginationCustom
                count={+data.certificates_aggregate.aggregate?.count!}
                page={+table.page}
                rowsPerPage={table.rowsPerPage}
                onPageChange={table.onChangePage}
                onRowsPerPageChange={table.onChangeRowsPerPage}
              />
            )}
          </FormProvider>
        </Card>
      </AppLoadingAndErrorWrapper>
    </Container>
  );
};

export default Certificates;
